import React from 'react';

const StatusDot = (props) => {
  const { children, className, large, style } = props;
  return (
    <div className="d-flex flex-row align-items-center">
      <span
        style={style}
        className={`status-dot ${large ? 'large' : 'small'} ${className}`}
      ></span>
      {children}
    </div>
  );
};

export default StatusDot;
